var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColorPicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.72,
    height: 21.658,
    viewBox: "0 0 20.72 21.658",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-617 7490.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(78.171 80.167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M881.436,409.689c-.833,0-1.666-.017-2.5.008-.357.011-.5-.124-.5-.633q.027-2.492,0-4.985c0-.458.1-.622.462-.619q2.542.033,5.085,0c.34,0,.476.12.476.6q-.021,2.523,0,5.045c0,.432-.106.6-.438.589C883.162,409.675,882.3,409.689,881.436,409.689Z",
    transform: "translate(-332.391 -7974.124)",
    fill: "#e84444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.437,409.688c-.847,0-1.7-.013-2.543,0-.317,0-.45-.113-.445-.572.018-1.7.014-3.406,0-5.11,0-.4.087-.559.406-.556q2.587.021,5.175,0c.3,0,.422.111.419.537q-.021,2.585,0,5.17c0,.439-.137.534-.427.529C969.163,409.678,968.3,409.688,967.437,409.688Z",
    transform: "translate(-410.903 -7974.115)",
    fill: "#a174be"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.444,487.572c-.846,0-1.692-.019-2.538,0-.338.011-.476-.109-.476-.592q.023-2.522,0-5.044c0-.476.131-.6.476-.6,1.692.019,3.384.024,5.077,0,.386,0,.476.184.476.657q-.024,2.463,0,4.927c0,.476-.088.669-.476.654C883.139,487.548,882.29,487.572,881.444,487.572Z",
    transform: "translate(-332.384 -8044.305)",
    fill: "#2abbc7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.444,487.572c-.846,0-1.692-.019-2.538,0-.338.011-.476-.109-.476-.592q.023-2.522,0-5.044c0-.476.131-.6.476-.6,1.692.019,3.384.024,5.077,0,.386,0,.476.184.476.657q-.024,2.463,0,4.927c0,.476-.088.669-.476.654C883.139,487.548,882.29,487.572,881.444,487.572Z",
    transform: "translate(-339.601 -8044.305)",
    fill: "#27a6fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.5,565.548c-.862,0-1.723-.016-2.584.01-.323,0-.451-.116-.447-.567q.02-2.555,0-5.111c0-.394.082-.564.4-.56q2.606.025,5.211,0c.326,0,.4.175.4.565q-.014,2.555,0,5.111c0,.456-.133.57-.451.56C883.193,565.534,882.347,565.548,881.5,565.548Z",
    transform: "translate(-332.418 -8114.569)",
    fill: "#f8cf97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.424,565.559c-.846,0-1.693-.016-2.538.008-.332.01-.476-.084-.476-.586.021-1.7.017-3.407,0-5.111,0-.424.108-.543.413-.54q2.584.021,5.166,0c.293,0,.427.084.424.524q-.024,2.584,0,5.172c0,.418-.1.55-.411.542C969.146,565.545,968.288,565.559,967.424,565.559Z",
    transform: "translate(-410.869 -8114.577)",
    fill: "#004eff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.448,481.4c.863,0,1.726.016,2.588-.008.318-.01.409.143.406.552-.013,1.707-.017,3.413,0,5.118,0,.459-.119.568-.44.565q-2.566-.025-5.131,0c-.333,0-.436-.138-.432-.579.017-1.686.02-3.374,0-5.06-.006-.491.119-.608.466-.6C965.752,481.414,966.6,481.4,967.448,481.4Z",
    transform: "translate(-410.894 -8044.346)",
    fill: "#01f1a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.589,565.558c-.847,0-1.7-.013-2.543.008-.3,0-.42-.11-.417-.538q.021-2.589,0-5.179c0-.386.092-.521.383-.519q2.61.019,5.221,0c.326,0,.4.172.4.567q-.018,2.561,0,5.12c0,.414-.1.559-.409.551C797.344,565.544,796.466,565.558,795.589,565.558Z",
    transform: "translate(-253.801 -8114.578)",
    fill: "#fdde30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.6,409.668c-.847,0-1.7-.013-2.542,0-.32,0-.449-.114-.444-.572.018-1.7.014-3.4,0-5.107,0-.4.086-.561.4-.559q2.587.024,5.173,0c.3,0,.426.111.422.537q-.019,2.585,0,5.168c0,.442-.144.533-.431.528C797.329,409.66,796.472,409.668,795.6,409.668Z",
    transform: "translate(-253.79 -7974.098)",
    fill: "#fc6930"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorPicker);
export default __webpack_public_path__ + "static/media/color-picker.2ad076389c33fba0ba5a780a8066dd03.svg";
export { ForwardRef as ReactComponent };